import { Component, Input, Output, EventEmitter, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

export interface DropdownItem {
  id: string;
  label: string;
  icon?: string;
  disabled?: boolean;
  divider?: boolean;
}

@Component({
  selector: 'app-sl-dropdown',
  standalone: true,
  imports: [NgFor, NgIf],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <sl-dropdown [placement]="placement" [distance]="distance">
      <sl-button slot="trigger" [variant]="triggerVariant" [size]="triggerSize" caret>
        <sl-icon *ngIf="triggerIcon" [name]="triggerIcon" slot="prefix"></sl-icon>
        {{ triggerLabel }}
      </sl-button>
      
      <sl-menu>
        <ng-container *ngFor="let item of items">
          <sl-divider *ngIf="item.divider"></sl-divider>
          <sl-menu-item 
            *ngIf="!item.divider"
            [disabled]="item.disabled"
            (click)="onItemClick(item)">
            <sl-icon *ngIf="item.icon" [name]="item.icon" slot="prefix"></sl-icon>
            {{ item.label }}
          </sl-menu-item>
        </ng-container>
      </sl-menu>
    </sl-dropdown>
  `,
  styleUrls: ['./sl-dropdown.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SlDropdownComponent {
  @Input() items: DropdownItem[] = [];
  @Input() triggerLabel: string = 'Actions';
  @Input() triggerIcon?: string;
  @Input() triggerVariant: 'default' | 'primary' | 'success' | 'neutral' | 'warning' | 'danger' | 'text' = 'default';
  @Input() triggerSize: 'small' | 'medium' | 'large' = 'small';
  @Input() placement: string = 'bottom-end';
  @Input() distance: number = 4;

  @Output() itemSelected = new EventEmitter<DropdownItem>();

  onItemClick(item: DropdownItem): void {
    if (!item.disabled) {
      this.itemSelected.emit(item);
    }
  }
}
